'use strict';

export default angular
  .module('maestro.filters.salesTaxRate', [])

  .filter('salesTaxRate', function() {
    return function(value) {
      return !value ? '' : (Math.round(value * 10000) / 100).toString() + '%';
    };
  })

  .name;
